import axios from 'axios'
import global from '@/global/variable.js'

// 获取日统计数据
export function getGateList(data) {
  const url = global.requestUrl + '/statistical/dayReport'
  return axios.get(url)
}

// 获取日统计数据
export function getEquipmentList(data) {
  const url = global.requestUrl + '/statistical/equipmentState'
  return axios.get(url)
}

// 获取预约列表
export function getManOrderList(data) {
  const url = global.requestUrl + '/personOrder/list?limit=' + data.limit + '&page=' + data.page
              + '&startDate=' + data.start + '&endDate=' + data.end 
              + '&name=&gate=9&status=9'
  return axios.get(url)
}

// 获取预约列表
export function getTruckOrderList(data) {
  const url = global.requestUrl + '/truckOrder/list?limit=' + data.limit + '&page=' + data.page
              + '&startDate=' + data.start + '&endDate=' + data.end 
              + '&plateNumber=&status=9'
  return axios.get(url)
}

// 获取访问列表
export function getManAccessList(data) {
  const url = global.requestUrl + '/personAccess/list?limit=' + data.limit + '&page=' + data.page
              + '&startDate=' + data.start + '&endDate=' + data.end 
              + '&gate=9&type=9&name='
  return axios.get(url)
}

// 获取访问列表
export function getTruckAccessList(data) {
  const url = global.requestUrl + '/truckAccess/list?limit=' + data.limit + '&page=' + data.page
              + '&startDate=' + data.start + '&endDate=' + data.end 
              + '&truckType=&plateNumber='
  return axios.get(url)
}

// 获取过磅列表
export function getWeighBridgeList(data) {
  const url = global.requestUrl + '/weighbridge/list?limit=' + data.limit + '&page=' + data.page
              + '&startDate=' + data.start + '&endDate=' + data.end 
              + '&type=9&status=9&plateNumber='
  return axios.get(url)
}

// 获取灌料列表
export function getMaterialCheckList(data) {
  const url = global.requestUrl + '/dualCheck/list?limit=' + data.limit + '&page=' + data.page
              + '&startDate=' + data.start + '&endDate=' + data.end 
              + '&status=9&plateNumber='
  return axios.get(url)
}